'use strict';

var _ = require('lodash');
var SponsorMarketTransformerFactory = function SponsorMarketTransformerFactory(DataTransformer, momentService) {
  function SponsorMarketTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'sponsor-forecast-market';
    this.priority = 1;
  }
  SponsorMarketTransformer.prototype = Object.create(DataTransformer.prototype);
  SponsorMarketTransformer.constructor = SponsorMarketTransformer;
  SponsorMarketTransformer.prototype.canTransform = function (sourceType) {
    return this.sourceType === sourceType;
  };
  SponsorMarketTransformer.prototype.isCacheable = function () {
    return true;
  };
  SponsorMarketTransformer.prototype.getCacheKey = function () {
    return this.sourceType;
  };
  SponsorMarketTransformer.prototype.transform = function (data) {
    if (data.domain.flattenedAggregatedMarketDemand === undefined) {
      return undefined;
    }
    var memoizedMomentOfDate = _.memoize(getMomentOfDate);
    return _.transform(data.domain.flattenedAggregatedMarketDemand, function (result, entry) {
      return result.push({
        departureDate: memoizedMomentOfDate(entry.departureDate, momentService.FIELD.DEPARTURE_DATE),
        regularReservationHoldingsTotal: entry.regularReservationHoldingsTotal,
        regularRevenueTotal: entry.regularRevenueTotal,
        mappedReservationHoldingsTotal: entry.mappedReservationHoldingsTotal,
        mappedRevenueTotal: entry.mappedRevenueTotal
      });
    });
  };
  function getMomentOfDate(date, field) {
    return momentService.of(date, field);
  }
  return SponsorMarketTransformer;
};
SponsorMarketTransformerFactory.$inject = ['DataTransformerFactory', 'MomentService'];
module.exports = SponsorMarketTransformerFactory;